import React from 'react';
import './coreLayout.scss';

// Note: Stateless/function components *will not* hot reload!
// react-transform *only* works on component classes.
//
// Since layouts rarely change, they are a good place to
// leverage React's new Stateless Functions:
// https://facebook.github.io/react/docs/reusable-components.html#stateless-functions
//
// CoreLayout is a pure function of its props, so we can
// define it with a plain javascript function...

interface Props {
  children: React.ReactNode;
}

const CoreLayout: React.FC<Props> = ({ children }: Props): JSX.Element => {
  return <div className="layout">{children}</div>;
};

export default CoreLayout;
